import axios from 'axios';
import { mt5accountsPlatformSlugs, mt5positionStatuses } from 'common/constants/accounts';

const validateStatus = status => status < 500;

export const getClientCustomPages = () => axios.get('/utils/custom_pages/client/');

export const getTradingAccountTypes = () => axios.get('/platforms/account_type/');

export const getTradingAccountList = search => axios.get('/platforms/account/', { params: { ...search } });

export const getAccountsPrefetch = search => axios.get('/platforms/account_prefetch/', { params: { ...search } });

export const getTradingAccount = id => axios.get(`/platforms/account/${id}/`, { validateStatus });

export const getMTServersAPI = () => axios.get(`/invest/metadata/`);

export const getMTServersNewAPI = () => axios.get(`/invest_crm/strategy/metadata`);

export const getTradingAccountOperations = (id, status = 'open', start, end, accountPlatformSlug) => {
  if (mt5accountsPlatformSlugs.includes(accountPlatformSlug) && mt5positionStatuses.includes(status)) {
    const dateParams = status !== 'open' ? { start, end } : {};

    return axios.get(`/platforms/account/${id}/position/list/${status}/`, {
      params: dateParams,
    });
  }

  return axios.get(`/platforms/account/${id}/${status}_trades/`, {
    params: start && end ? { start, end } : undefined,
  });
};

export const getPartnerAccounts = referType => axios.get(`/partnership/systems/account/list/${referType}`);
export const getPartnerAccount = accountId => axios.get(`/partnership/systems/account/${accountId}/`);
export const getPartnerAccountCommissions = (accountId, search) =>
  axios.get(`/partnership/systems/account/${accountId}/commissions/`, { params: { ...search } });
